import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import {ITenant} from 'app/common/interfaces/tenant/ITenant';
import {IIntegration} from 'app/common/interfaces/IIntegration';
import {IUser} from 'app/common/interfaces/IUser';

@Injectable({
  providedIn: 'root',
})
export class SentryService {

  constructor() { }

  setUserContext(user: IUser, tenant: ITenant, integration: IIntegration): void {
    Sentry.setUser({
      id: user.id,
      email: user.email,
    });

    Sentry.setContext('tenant', {
      userName: user.name,
      tenantId: tenant.id,
      tenantName: tenant.name,
      pricingPlan: tenant.pricingPlan,
      integrationType: integration.integrationType,
    });
  }
}
